import api from './api';

export interface WatchlistBoardRow {
  symbol: string; exchange: string;
  price: number | null; pctChange: number | null;
  spark: number[];
  score: number | null; zone: string | null; htfZone: string | null;
  error?: string;
}

export interface UnlistedTrackedRow { symbol: string; exchange: string; name?: string; price: number | null; }

/** Watchlist hub API. */
export const watchlistService = {
  list: () => api.get('/watchlists'),
  board: (id: number, interval = 60) => api.get(`/watchlists/${id}/board`, { params: { interval } }),
  addSymbol: (id: number, symbol: string, exchange: string) => api.post(`/watchlists/${id}/symbols`, { symbol, exchange }),
  removeSymbol: (id: number, symbol: string, exchange: string) => api.delete(`/watchlists/${id}/symbols`, { params: { symbol, exchange } }),
  create: (name: string) => api.post('/watchlists', { name, symbols: [] }),
  remove: (id: number) => api.delete(`/watchlists/${id}`),
  /** Tracked instruments not yet in any of the user's watchlists (item 5). */
  unlistedTracked: () => api.get('/watchlists/unlisted-tracked'),
};
